module.exports = __webpack_public_path__ + "static/003-e4cfe952fd3d7bebaae7a0fd24a0657a.jpg";